import { isValidPhoneNumber } from "libphonenumber-js";

export const isValidPhoneMask = (phone: string | undefined) => {
  if (phone) {
    return isValidPhoneNumber(phone);
  }
  return false;
};
